import {PropertyBase} from "./PropertyBase";
import * as React from "react";
import {SlateEditor} from "shared/controls/SingleInputs/SlateEditor/SlateEditor";
import {FontFamilyMark} from "InternalShared/PageBuilder/Controls/Properties/marks/FontFamilyMark/FontFamilyMark";
import {RNCodeMirror} from "shared/controls/SingleInputs/CodeMirror/RNCodeMirror";

declare let rednaoPDFInvoiceParams:any;

export class HtmlProperty extends PropertyBase{
    public label:string='Text';
    private elementID:string;


    public SubRenderer(): React.ReactNode {
        return(
            <RNCodeMirror Label={this.label} Store={this.Options} PropertyName={this.OptionsPropertyName} onChange={e=>{this.toolItem.Refresh()}} />
        )
    }



}

